import React from 'react';
import { Empty } from 'antd';
import AttritionPage from '../../pages/AttritionPage';
import WindowNote from './WindowNote';

/**
 * Who left: the attrition page's Detail table, one row per team, job and
 * month.
 */
export default function AttritionTab({ teamId, team, from, to }) {
  if (!teamId) {
    return <Empty description="Select a team" image={Empty.PRESENTED_IMAGE_SIMPLE} style={{ marginTop: 40 }} />;
  }
  return (
    <>
      <WindowNote from={from} to={to} />
      <AttritionPage embedded teamId={teamId} from={from} to={to} sections={['detail']} />
    </>
  );
}
